/* eslint-disable no-underscore-dangle */

'use strict';

/**
 * initializes boldmetrics on the pdp.
 * Boldmetrics data would be undefined if boldmetrics site pref is disabled
 */
function init() {
    const boldMetricsWrapper = document.querySelector('#boldmetrics-ssc-default');
    const boldmetricsData = boldMetricsWrapper ? boldMetricsWrapper.dataset.boldmetrics : null;
    if (boldmetricsData) {
        window._boldmetrics = JSON.parse(boldmetricsData);
    }
}

/**
 * Sends the purchase data on order confirmation
 * called from orderConfirmation.js
 */
function sendPurchaseData() {
    const boldmetricsScriptElement = document.querySelector('#boldmetrics-purchase-script');
    let boldmetricsPurchaseData = boldmetricsScriptElement ? boldmetricsScriptElement.dataset.boldmetricsPurchase : null;
    // only make the call if purchase data is present
    if (boldmetricsPurchaseData) {
        boldmetricsScriptElement.addEventListener('load', function () {
            window.bmiWriteTransaction(JSON.parse(boldmetricsPurchaseData));
        });
    }
}

/**
 * Handles the "Select Size" button click event in the Apparel Fit Tool.
 * While implementing EL-2025 it was shown that the second size that would be used for cup in the tool is not consistent with our buttons.
 * We are accepting that the first size will be the only value selected, the user will still have to manually select the second size after the space (cup)
 * @param {Object} bmEventObject - The event triggered by the "Select Size" button.
 */
function clickSizeFromApparelFitTool(bmEventObject) {
    const size = bmEventObject.detail.size;

    // Extract the first part of the size if it contains a space
    const sizeToSelect = size.includes(' ') ? size.split(' ')[0] : size;

    // Find the corresponding button for the size
    const sizeButton = document.body.querySelector(`button.selectable[data-attrvalue="${sizeToSelect}"]`);

    // Click the button if it exists and is not already selected
    if (sizeButton && !sizeButton.classList.contains('selected')) {
        sizeButton.click();
    }
}

// Event Listener for when the user clicks the "Select Size" button in the Apparel Fit Tool
document.addEventListener('bmi_add_to_cart', function (e) {
    clickSizeFromApparelFitTool(e);
});

module.exports = {
    init: init,
    sendPurchaseData: sendPurchaseData
};
